var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"main"},[_c('img'),_c('p',[_vm._v("© 2020-2023 Alpha fund management Pte. Ltd. All rights reserved.")])])])
}]

export { render, staticRenderFns }